import { PropsWithChildren, useState } from 'react'
import { useFocusWithin } from '@react-aria/interactions'
export const TypeaheadField = ({ children }: PropsWithChildren) => {
  const [isFocusWithin, setIsFocusWithin] = useState(false)
  const { focusWithinProps } = useFocusWithin({
    onFocusWithinChange: (isFocusWithin) => setIsFocusWithin(isFocusWithin),
  })

  return (
    <div {...focusWithinProps} data-hide-typeahead-suggestions={!isFocusWithin}>
      {children}
    </div>
  )
}
